import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Button,
  StapleTableBody,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
} from '@insurancemenu/imenu-components-lib/dist/components';
import SelfRegisteredSubDependentDelegate from 'store/modules/subscriber/subscriber-basic-info/dependents/subDependentDelegate';
import { colors } from '@insurancemenu/imenu-components-lib';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import SubscriberBasicInfoDelegate from 'store/modules/subscriber/subscriber-basic-info/subscriberBasicInfoDelegate';
import DependentTableRow from './DependentTableRow';
import { SUBSCRIBER_DEPENDENTS_TABLE_TEST_ID, ADD_DEPENDENT_BUTTON_TEST_ID } from './constants';
import { StapleTableStyled } from './styles';

interface Props {
  isLoading: boolean;
  dependentDelegates: SelfRegisteredSubDependentDelegate[];
  subscriberBasicInfo: SubscriberBasicInfoDelegate | null;
  formId: string;
  onAddDependent?: () => void;
}

const SubscriberDependentsTable: React.FC<Props> = observer(
  ({ isLoading, dependentDelegates, subscriberBasicInfo, formId, onAddDependent }) => {
    return (
      <StapleTableStyled
        data-test-id={SUBSCRIBER_DEPENDENTS_TABLE_TEST_ID}
        totalElements={dependentDelegates.length}
        loading={isLoading}
      >
        <StapleTableHeader>
          <StapleTableRow>
            <StapleTableHeading width="10rem">Dependent Name</StapleTableHeading>
            <StapleTableHeading width="10rem">Relationship</StapleTableHeading>
            <StapleTableHeading width="10rem">Date of Birth</StapleTableHeading>
            <StapleTableHeading>
              {onAddDependent ? (
                <Button
                  color="custom"
                  size="medium"
                  customColor={colors.green[600]}
                  leftIconProp={<Add />}
                  onClick={onAddDependent}
                  data-test-id={ADD_DEPENDENT_BUTTON_TEST_ID}
                >
                  Add Dependent
                </Button>
              ) : null}
            </StapleTableHeading>
          </StapleTableRow>
        </StapleTableHeader>
        <StapleTableBody>
          {dependentDelegates.map((dependentDelegate) => (
            <DependentTableRow
              key={dependentDelegate.mainData.id}
              dependentDelegate={dependentDelegate}
              subscriberBasicInfo={subscriberBasicInfo!}
              formId={formId}
            />
          ))}
        </StapleTableBody>
      </StapleTableStyled>
    );
  },
);

export default SubscriberDependentsTable;
